module.exports = __webpack_public_path__ + "img/activity.90248c14.svg";